import { combineReducers } from "redux";
import { snackbarReducer } from "./snackbarReducer";
import { PaymentTypeReducer } from "./paymentTypeReducer";
import { userTypeReducer } from "./usertypesReducer";
import { BankReducer } from "./bankReducer";
//import { expensesTypeReducer } from "./expensesTypeReducer";
import {expansesCategoryReducer} from "./expansesCategoryReducer"
import { itemCategoryReducer } from "./itemCategoryReducer";
import { binReducer } from "./binReducer";
import { colourReducer } from "./colourReducer";
import { brandReducer } from "./brandReducer";
import { unitReducer } from "./unitReducer";
import {sizeReducer} from "./sizeReducer";
import { StockLocationReducer } from "./stockLocationReducer";
import { LastInsertInvoice } from "./lastInsertInvoiceReducer";
import { servicePacks } from "./servicePackReducer";
import { vehicleBrandReducer } from "./vehicleBrandReducer";
import { vehicleTypeReducer } from "./vehicleTypeReducer";
import { pendingUserReducer } from "./pendingUserReducer";
import { activeUserReducer } from "./activeUserReducer";
import { rejectUserReducer } from "./rejectUserReducer";
import { userReducer } from "./userReducer";
import { authReducer } from "./authReducer";
import { defaultLocationReducer } from "./defaultLocationReducer";
import {customerTypeReducer} from "./customerTypeReducer";
import {employeeTypeReducer} from "./employeeTypeReducer";
import {roomReducer} from "./roomReducer";
import {employeeReducer} from'./employeeReducer'
import {deskReducer} from './desckReducer';
import {deliverPartnerReducer} from "./deliveryPartnerReducer";
import { mainNavigationReducer } from "./mainNavigationReducer";
import { levelOneNavigationReducer } from "./levelOneNavigationReducer";
import { levelTwoNavigationReducer } from "./levelTwoNavigationReducer";
import { reportMainNavigationReducer } from "./reportMainNavigationReducer";
import { reportLevelOneNavigationReducer } from "./reportLevelOneNavigationReducer";
import { roleReducer } from "./roleReducer";
import { itemDepartmentReducer } from "./itemDepartmentReducer";

const reducers = combineReducers({
  itemCategory: itemCategoryReducer,
  itemDepartment: itemDepartmentReducer,
  unit: unitReducer,
  snackbar: snackbarReducer,
  size:sizeReducer,
  //expensesType: expensesTypeReducer,
  expansesCategory:expansesCategoryReducer,
  paymentType: PaymentTypeReducer,
  userTypes: userTypeReducer,
  bank: BankReducer,
  bin: binReducer,
  colour: colourReducer,
  brand: brandReducer,
  location: StockLocationReducer,
  lastInsertInvoice: LastInsertInvoice,
  servicePack: servicePacks,
  vehicleBrand: vehicleBrandReducer,
  vehicleType: vehicleTypeReducer,
  activeUser: activeUserReducer,
  rejectUser: rejectUserReducer,
  pendingUser: pendingUserReducer,
  user: userReducer,
  role: roleReducer,
  auth: authReducer,
  defaultLocation: defaultLocationReducer,
  customerType:customerTypeReducer,
  employeeType:employeeTypeReducer,
  room:roomReducer,
  employee:employeeReducer,
  desk:deskReducer,
  deliveryPartner:deliverPartnerReducer,
  mainNavigation:mainNavigationReducer,
  levelOneNavigation:levelOneNavigationReducer,
  levelTwoNavigation:levelTwoNavigationReducer,
  reportMainNavigation:reportMainNavigationReducer,
  reportLevelOneNavigation:reportLevelOneNavigationReducer,
});
export default reducers;
